module.exports = __webpack_public_path__ + "static/in-the-nutshell-ef88ff3bb1bbd6152bff2f5e0d0d5531.png";